import { render, staticRenderFns } from "./ToCoins.vue?vue&type=template&id=42773ac9&"
import script from "./ToCoins.vue?vue&type=script&lang=js&"
export * from "./ToCoins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports